import React from 'react'
import TeamContainer from './team-container'
import ChannelsContainer from './channels-container'
import InvoicesContainer from './invoices-container'
import SubscriptionsContainer from './subscriptions-container'
import PaymentMethodsContainer from './payment-methods-container'
import SettingsContainer from './settings-container'
import { useHistory } from 'react-router-dom'
import './style.scss'

const Index = ({activeDisplay, setActiveDisplay}) => {

    const history = useHistory()

    const renderView = () => {
        switch(activeDisplay){
            case "team":
                return <TeamContainer/>
            case "channels":
                return <ChannelsContainer/>
            case "invoices":
                return <InvoicesContainer/>
            case "subscriptions":
                return <SubscriptionsContainer/>
            case "paymentmethods":
                return <PaymentMethodsContainer/>
            case "settings":
                return <SettingsContainer/>
            default:
                return null
        }
    }

    return(
        <section className="dashboard-company-bottom-row-section">
            {renderView()}
        </section>
    )
}

export default Index